<template>
  <div class="string-list-input">
    <v-text-field
      v-for="(input, i) in inputsWithEmptyField"
      :key="i"
      :value="input"
      :placeholder="placeholder"
      class="mt-0 pt-0 text-body-2"
      hide-details
      clearable
      @input="onInputChange(i, $event)"
      @blur="removeEmptyFields"
    />
    <span class="add-new" @click="onAddNew">+ Add New</span>
  </div>
</template>

<script>
export default {
  name: 'StringListInput',
  props: {
    inputs: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Enter value',
    },
  },
  emits: ['update:inputs'],
  computed: {
    inputsWithEmptyField() {
      // Add an empty field if the last field is not empty
      const inputs = [...(this.inputs ?? [])];
      if (inputs.length === 0) {
        inputs.push('');
      }
      return inputs;
    },
  },
  methods: {
    onAddNew() {
      this.$emit('update:inputs', [...this.inputsWithEmptyField, '']);
    },
    onInputChange(i, value) {
      const inputs = [...this.inputsWithEmptyField];
      inputs[i] = value;
      this.emitNonEmptyInputs(inputs);
    },
    removeEmptyFields() {
      this.emitNonEmptyInputs(this.inputs || []);
    },
    emitNonEmptyInputs(inputs) {
      const nonEmptyInputs = inputs.filter(
        (input) => input && input.trim()
      );
      this.$emit(
        'update:inputs',
        nonEmptyInputs.length === 0 ? undefined : nonEmptyInputs
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.string-list-input {
  display: grid;
  gap: 16px;

  .add-new {
    cursor: pointer;
    color: var(--v-primary-base);
    font-size: 12px;
    font-weight: 300;
  }
}
</style>
